"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortfolioCovenantDirectInsertRecordsStruct = exports.PortfolioCovenantDirectInsertRecordStruct = exports.PortfolioCovenantLoanTapeMetadataSchema = exports.PortfolioCovenantLoanTapeMetadataValueSchema = exports.AllPortfolioCovenantLoanTapeMetadataParamsSchema = exports.AllPortfolioCovenantLoanTapeMetadataParamsIterable = exports.PORTFOLIO_COVENANT_LOAN_TAPE_METADATA_PARAMS_KEY_VALUE_DELIMITER = exports.PORTFOLIO_COVENANT_LOAN_TAPE_METADATA_PARAMS_KEY_VALUE_SEPARATOR = exports.PORTFOLIO_COVENANT_LOAN_TAPE_METADATA_PARAMS_START_ANCHOR = exports.PortfolioCovenantLoanTapeMetadataParamsSchema = exports.PortfolioCovenantLoanTapeMetadataResponsePropertySchema = exports.PortfolioCovenantLoanTapeMetadataResponsePropertyIterable = exports.PortfolioCovenantWorkleaseSchema = exports.PortfolioCovenantIdMapSchema = exports.SuccessPortfolioCovenantWithCreatedAtSchema = exports.PortfolioCovenantSchema = exports.InitializedOrErrorPortfolioCovenantWithIdSchema = exports.SuccessPortfolioCovenantWithIdAndVersionSchema = exports.SuccessPortfolioCovenantSchema = exports.InitializedOrErrorPortfolioCovenantSchema = exports.BasePortfolioCovenantSchema = exports.PortfolioCovenantWorkleaseModeSchema = exports.PortfolioCovenantResultSchema = exports.PortfolioCovenantMetadataSchema = exports.PortfolioCovenantStatusSchema = exports.PortfolioCovenantStatusIterable = exports.PortfolioCovenantResultIterable = void 0;
const zod_1 = require("zod");
const CreditAgreement_1 = require("./CreditAgreement");
const Date_1 = require("./Date");
const Utils_1 = require("./Utils");
exports.PortfolioCovenantResultIterable = [
    'PASS',
    'FAIL',
    'LEVEL_1_FAIL',
    'LEVEL_2_FAIL',
    'LEVEL_3_FAIL',
    'LEVEL_4_FAIL',
    'LEVEL_5_FAIL',
    'LEVEL_6_FAIL',
    'LEVEL_7_FAIL',
    'LEVEL_8_FAIL',
    'LEVEL_9_FAIL',
    'LEVEL_10_FAIL',
];
exports.PortfolioCovenantStatusIterable = ['initialized', 'success', 'error'];
exports.PortfolioCovenantStatusSchema = zod_1.z.enum(exports.PortfolioCovenantStatusIterable);
exports.PortfolioCovenantMetadataSchema = zod_1.z.object({
    errors: zod_1.z.array(zod_1.z.string()),
});
exports.PortfolioCovenantResultSchema = zod_1.z.enum(exports.PortfolioCovenantResultIterable);
exports.PortfolioCovenantWorkleaseModeSchema = zod_1.z.enum(['QA', 'RESULT']);
exports.BasePortfolioCovenantSchema = zod_1.z.object({
    covenantKey: zod_1.z.string(),
    creditFacilityId: zod_1.z.string(),
    creditAgreementId: zod_1.z.string(),
    value: zod_1.z.number().nullable(),
    result: exports.PortfolioCovenantResultSchema.nullable(),
    reportingDate: Utils_1.ZodFullDateStrForJsonSchemaStruct.nullable(),
    triggerDate: Utils_1.ZodFullDateStrForJsonSchemaStruct,
    variables: zod_1.z.array(CreditAgreement_1.Config.QueryResultSchema).nullable(),
    warnings: zod_1.z.array(zod_1.z.string()).nullable(),
    status: exports.PortfolioCovenantStatusSchema,
    metadata: exports.PortfolioCovenantMetadataSchema.nullable(),
    mode: exports.PortfolioCovenantWorkleaseModeSchema,
});
exports.InitializedOrErrorPortfolioCovenantSchema = exports.BasePortfolioCovenantSchema.extend({
    value: zod_1.z.null(),
    result: zod_1.z.null(),
    reportingDate: zod_1.z.null(),
    variables: zod_1.z.null(),
    warnings: zod_1.z.null(),
    status: zod_1.z.enum(['initialized', 'error']),
});
exports.SuccessPortfolioCovenantSchema = exports.BasePortfolioCovenantSchema.extend({
    result: exports.PortfolioCovenantResultSchema,
    reportingDate: Utils_1.ZodFullDateStrForJsonSchemaStruct,
    variables: zod_1.z.array(CreditAgreement_1.Config.QueryResultSchema),
    warnings: zod_1.z.array(zod_1.z.string()),
    status: zod_1.z.literal('success'),
});
exports.SuccessPortfolioCovenantWithIdAndVersionSchema = exports.SuccessPortfolioCovenantSchema.extend({
    id: zod_1.z.string(),
    version: zod_1.z.number(),
});
exports.InitializedOrErrorPortfolioCovenantWithIdSchema = exports.InitializedOrErrorPortfolioCovenantSchema.extend({
    id: zod_1.z.string(),
});
exports.PortfolioCovenantSchema = zod_1.z.union([
    exports.InitializedOrErrorPortfolioCovenantWithIdSchema,
    exports.SuccessPortfolioCovenantWithIdAndVersionSchema,
]);
exports.SuccessPortfolioCovenantWithCreatedAtSchema = exports.SuccessPortfolioCovenantWithIdAndVersionSchema.extend({
    // eslint-disable-next-line camelcase
    created_at: zod_1.z.date(),
    // eslint-disable-next-line camelcase
    updated_at: zod_1.z.date(),
});
exports.PortfolioCovenantIdMapSchema = zod_1.z.object({
    covenantKey: zod_1.z.string(),
    portfolioCovenantId: zod_1.z.string(),
});
// this is what gets sent to the port cov lambda
exports.PortfolioCovenantWorkleaseSchema = zod_1.z.object({
    creditAgreementId: zod_1.z.string(),
    creditFacilityId: zod_1.z.string(),
    triggerDate: Utils_1.ZodFullDateStrForJsonSchemaStruct,
    mode: exports.PortfolioCovenantWorkleaseModeSchema,
    covenantKeyPortCovIdMap: zod_1.z.array(exports.PortfolioCovenantIdMapSchema), // id for existing port covs record (from initialized record)
});
exports.PortfolioCovenantLoanTapeMetadataResponsePropertyIterable = [
    'result',
    'value',
];
exports.PortfolioCovenantLoanTapeMetadataResponsePropertySchema = zod_1.z.enum(exports.PortfolioCovenantLoanTapeMetadataResponsePropertyIterable);
// we encode portfolio covenant loan tape metadata query params into formula engine value
// utilizing `__` as an anchor to start the params, `.` for key.value association, and `_` for key value pair delimiter
// example of query string (less loanTapeMetadata prefix)
// portfolioCovenants__key.<portCovKey>_reportingPeriod.<reportingPeriod>_responseProperty.<responseProperty>_<optionalParam1Key>.<optionalParam1Value>
// we cannot use characters like | ~ & ? here due to hyperformula limitations
// https://hyperformula.handsontable.com/guide/named-expressions.html#examples
exports.PortfolioCovenantLoanTapeMetadataParamsSchema = zod_1.z.object({
    queryString: zod_1.z.string(),
    key: zod_1.z.string(),
    responseProperty: exports.PortfolioCovenantLoanTapeMetadataResponsePropertySchema,
    reportingPeriod: Date_1.Reporting.ReportingPeriodSchema,
});
exports.PORTFOLIO_COVENANT_LOAN_TAPE_METADATA_PARAMS_START_ANCHOR = '__';
exports.PORTFOLIO_COVENANT_LOAN_TAPE_METADATA_PARAMS_KEY_VALUE_SEPARATOR = '.';
exports.PORTFOLIO_COVENANT_LOAN_TAPE_METADATA_PARAMS_KEY_VALUE_DELIMITER = '_';
exports.AllPortfolioCovenantLoanTapeMetadataParamsIterable = [
    ...Date_1.Reporting.AllReportingPeriodPropertiesIterable,
    'key',
    'responseProperty',
];
exports.AllPortfolioCovenantLoanTapeMetadataParamsSchema = zod_1.z.enum(exports.AllPortfolioCovenantLoanTapeMetadataParamsIterable);
exports.PortfolioCovenantLoanTapeMetadataValueSchema = zod_1.z.union([
    exports.PortfolioCovenantResultSchema,
    zod_1.z.number(),
    zod_1.z.null(),
]);
exports.PortfolioCovenantLoanTapeMetadataSchema = zod_1.z.object({
    // this is "formula engine variable" (less loanTapeMetadata prefix)
    queryString: zod_1.z.string(),
    value: exports.PortfolioCovenantLoanTapeMetadataValueSchema,
});
exports.PortfolioCovenantDirectInsertRecordStruct = zod_1.z.object({
    portfolioCovenantKey: zod_1.z.string(),
    value: zod_1.z.number(),
});
exports.PortfolioCovenantDirectInsertRecordsStruct = zod_1.z.array(exports.PortfolioCovenantDirectInsertRecordStruct);
//# sourceMappingURL=PortfolioCovenant.js.map